// Cookie names shared between the fronts and the API.
//
// The API writes these cookies (see api/src/utils/authCookie.ts, the source
// of truth on the server side); the fronts only read them. The names must
// stay identical across both apps — change them in both places at once.

/**
 * Name of the JS-readable "an SSO cookie probably exists" companion cookie the
 * API sets alongside the HttpOnly auth cookie (source of truth:
 * api/src/utils/authCookie.ts). Lets an anonymous SPA skip the auth boot probe:
 * no hint cookie → no SSO auth cookie → refreshAuthTokens is guaranteed to 401.
 */
export const SSO_HINT_COOKIE_NAME = "sso_hint";
